import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import DateAdapter from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { enGB } from "date-fns/locale";
import moment from "moment";

import { alertActions, ordersActions } from "../../../redux/actions";
import { siteConstants } from "../../../constants";

const OrdersPage = (props) => {
  const defaultStartDate = new Date();
  defaultStartDate.setDate(defaultStartDate.getDate() - siteConstants.ORDER_LIST_DAYS);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(new Date());
  const [orders, setOrders] = useState([]);

  const handleRefreshOrders = () => {
    props.alertReset();
    props.listOrders(startDate, endDate);
  }

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 120, },
    { field: "source", headerName: "Source", width: 150, },
    {
      field: "csReport",
      headerName: "CS Report",
      width: 130,
      align: "left",
      renderCell: (params) => {
        return (
          <Link
            href={`/assessment-report/?id=${params.value}`}
            target="_blank"
            rel="noopener"
          >
            {params.value?.slice(-8)}
          </Link>
        );
      },
    },
    { field: "clientName", headerName: "Client Name", flex: 1, },
    { field: "clientEmail", headerName: "Client Email", flex: 1, },
    { field: "bundle", headerName: "Bundle", width: 120, },
    {
      field: "price",
      headerName: "Price",
      width: 120,
      align: "right",
    },
    { field: "receipt", headerName: "Receipt", width: 160, },
    { field: "timestamp", headerName: "Timestamp", width: 160, },
  ];

  useEffect(() => {
    const _orders = [];
    if (props.orders) {
      props.orders.map((order) => {
        const timestamp = moment(order.modified);
        if (order.cs_reports.length > 0) {
          _orders.push({
            id: order.id.slice(-8),
            source: order.visitor.source,
            csReport: order.cs_reports[0].id,
            clientName: order.cs_reports[0].client_name,
            clientEmail: order.client_email,
            bundle: order.bundle?.name,
            price: order.receipt?.amount,
            receipt: order.receipt?.id,
            timestamp: timestamp.fromNow(),
          });
        }
      });
    }
    setOrders(_orders);
  }, [props.orders])

  useEffect(() => {
    props.alertReset();
    props.listOrders(startDate, endDate);
  }, [startDate])

  useEffect(() => {
    props.alertReset();
    props.listOrders(startDate, endDate);
  }, [endDate])

  useEffect(() => {
    props.alertReset();
  }, [])

  return (
    <>
      <Helmet>
        <title>Orders</title>
      </Helmet>

      <LocalizationProvider dateAdapter={DateAdapter} locale={enGB}>
        <Container
          maxWidth="xl"
          sx={{
            marginTop: "30px",
            textAlign: "left",
          }}
        >
          <Typography variant="h4">Orders</Typography>
          {
            props.alert.message &&
            <Alert variant="outlined" severity={ props.alert.type }>
              { props.alert.message }
            </Alert>
          }
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <DatePicker
              label="Start date"
              value={startDate}
              maxDate={new Date()}
              onChange={(newDate) => {
                setStartDate(newDate)
              }}
              renderInput={(params) => <TextField {...params} />}
            />
            <DatePicker
              label="End date"
              value={endDate}
              maxDate={new Date()}
              onChange={(newDate) => {
                setEndDate(newDate)
              }}
              renderInput={(params) => <TextField {...params} />}
            />
            <IconButton
              size="large"
              onClick={handleRefreshOrders}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
          <DataGrid
            rows={orders}
            columns={columns}
            autoHeight={true}
            density="compact"
            hideFooterSelectedRowCount={true}
            loading={props.isListingOrders}
          />
        </Container>
      </LocalizationProvider>
    </>
  );
}

const mapState = (state) => {
  const {
    isListingOrders,
    orders,
  } = state.orders;
  return {
    isListingOrders,
    orders,
    alert: state.alert,
  }
};

const actionCreators = {
  alertReset: alertActions.reset,
  listOrders: ordersActions.listOrders,
};

export default connect(mapState, actionCreators)(OrdersPage);